import { useCallback, useEffect, useState } from 'react';

import { REDIRECT_DELAY_MS } from '../../hooks/constants';

export const useAutoRedirect = (redirectUrl?: string, enabled = false) => {
    const [timeToRedirect, setTimeToRedirect] = useState(REDIRECT_DELAY_MS);

    const redirectToWallet = useCallback(() => {
        if (redirectUrl) {
            window.location.href = redirectUrl;
        }
    }, [redirectUrl]);

    useEffect(() => {
        if (!enabled || !redirectUrl) {
            return undefined;
        }

        const interval = setInterval(() => {
            setTimeToRedirect((prev) => {
                if (prev <= 1000) {
                    redirectToWallet();

                    return 0;
                }

                return prev - 1000;
            });
        }, 1000);

        return () => {
            clearInterval(interval);
        };
    }, [enabled, redirectToWallet, redirectUrl]);

    return {
        timeToRedirect,
        redirectToWallet,
    };
};
